interface JoinedMatch {
  id: string;
  best_of?: number | null;
  player_1_games: number | null;
  player_2_games: number | null;
}

export interface DrawMatchFactsRow {
  best_of?: number | null;
  event_match_schedule?: { best_of?: number | null; match?: JoinedMatch | null } | null;
}

export interface DrawMatchFacts {
  gamesWon: { player1: number; player2: number } | null;
  bestOf: number | null;
  scorecardMatchId: string | null;
}

/** Games won, format and scorecard id for a draw match, from the joined match row. */
export function drawMatchFacts(row: DrawMatchFactsRow): DrawMatchFacts {
  const match = row.event_match_schedule?.match ?? null;
  const gamesWon =
    match && match.player_1_games !== null && match.player_2_games !== null
      ? { player1: match.player_1_games, player2: match.player_2_games }
      : null;
  return {
    gamesWon,
    bestOf: match?.best_of ?? row.event_match_schedule?.best_of ?? row.best_of ?? null,
    scorecardMatchId: match?.id ?? null,
  };
}
